import { InvestProjectYear } from '../invest-project-year';

export class InvestProjectYearSic extends InvestProjectYear {
    spending: number;
    subsidies: number;
    ordinaryLevy: number;
    extraFund: number;
    extraBalance: number;
    estate: number;
    investmentFunctionCode: string;

    constructor(year: number) {
        super(year);

        this.spending = 0;
        this.subsidies = 0;
        this.ordinaryLevy = 0;
        this.extraFund = 0;
        this.extraBalance = 0;
        this.estate = 0;
        this.investmentFunctionCode = null;
    }
}
